/** The privacy contact as a mail link. */
export function ContactEmail({ contact }: { contact: string }): React.JSX.Element {
  return <a href={`mailto:${contact}`}>{contact}</a>;
}
